module.exports = __webpack_public_path__ + "spot/congrats-robots-placeholder.a82b8e.jpg";